export const isSame =
  <T>(a: T) =>
  (b: T) =>
    Object.is(a, b)
